import { useState } from 'react';
import { reviews } from '../../mocks/services';

export default function ReviewsCarousel() {
  const [currentReview, setCurrentReview] = useState(0);

  const nextReview = () => {
    setCurrentReview((prev) => (prev + 1) % reviews.length);
  };

  const prevReview = () => {
    setCurrentReview((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  return (
    <section className="py-12 sm:py-20 bg-[#1a1a1a] border-t-4 border-[#FFD700]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 sm:mb-12 gap-4">
          <h2 className="text-2xl sm:text-4xl font-black text-white">
            TRUSTED BY 500+ FRESNO HOMEOWNERS
          </h2>
          <div className="flex items-center gap-3">
            <div className="flex gap-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <i key={star} className="ri-star-fill text-[#FFD700] text-xl sm:text-2xl"></i>
              ))}
            </div>
            <span className="text-[#FFD700] text-2xl sm:text-3xl font-black">4.9/5.0</span>
          </div>
        </div>

        <div className="relative px-8 sm:px-12">
          <div className="overflow-hidden">
            <div className="flex transition-transform duration-500" style={{ transform: `translateX(-${currentReview * 100}%)` }}>
              {reviews.map((review) => (
                <div key={review.id} className="w-full flex-shrink-0">
                  <div className="bg-white rounded-2xl p-6 sm:p-10 max-w-4xl mx-auto">
                    <div className="flex gap-1 mb-4">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i key={star} className="ri-star-fill text-[#FFD700] text-lg sm:text-xl"></i>
                      ))}
                    </div>
                    <p className="text-gray-700 text-base sm:text-lg italic mb-4 sm:mb-6 leading-relaxed">
                      "{review.text}"
                    </p>
                    <div className="flex items-center gap-3 sm:gap-4">
                      <img 
                        src={review.avatar} 
                        alt={review.name}
                        className="w-12 h-12 sm:w-16 sm:h-16 rounded-full object-cover"
                      />
                      <div>
                        <div className="font-bold text-[#1a1a1a] text-sm sm:text-base">{review.name}</div>
                        {review.verified && (
                          <div className="inline-block bg-[#FFD700] text-[#1a1a1a] text-xs font-bold px-3 py-1 rounded-full mt-1">
                            Verified Customer
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button
            onClick={prevReview}
            className="absolute left-0 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border-2 border-[#FFD700] text-[#FFD700] rounded-full hover:bg-[#FFD700] hover:text-[#1a1a1a] transition-all cursor-pointer"
          >
            <i className="ri-arrow-left-line text-lg sm:text-xl"></i>
          </button>
          <button
            onClick={nextReview}
            className="absolute right-0 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border-2 border-[#FFD700] text-[#FFD700] rounded-full hover:bg-[#FFD700] hover:text-[#1a1a1a] transition-all cursor-pointer"
          >
            <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}